var Blocks = {};
export default Blocks = {
  "block 1": {
    title: "urban towns block 1",
    town: "urban",
    data: [
      {
        name: "ut-3 end upgrade",
        sqft: "1783",
        beds: "3"
      },
      {
        name: "ut-1 end upgrade",
        sqft: "1408",
        beds: "3"
      },    
      {
        name: "ut-3 end",
        sqft: "1783",
        beds: "3"
      }
    ]
  },
  "block 2": {
    title: "urban towns block 2",
    town: "urban",
    data: [
      {
        name: "ut-3 end",
        sqft: "1783",
        beds: "3"
      },
      {
        name: "ut-2",
        sqft: "1589",
        beds: "3"
      },
    ]
  },
  "block 3": {
    title: "urban towns block 3",
    town: "urban",
    data: [
      {
        name: "ut-3 end",
        sqft: "1783",
        beds: "3"
      },
      {
        name: "ut-1",
        sqft: "1408",
        beds: "3"
      },      
      {
        name: "ut-3 end upgrade",
        sqft: "1783",
        beds: "3"
      }
    ]
  },
  "block 5": {
    title: "urban towns block 5",
    town: "urban",
    data: [
      {
        name: "ut-3 end",
        sqft: "1783",
        beds: "3"
      },
      {
        name: "ut-1",
        sqft: "1408",
        beds: "3"
      },      
      {
        name: "ut-4 corner",
        sqft: "1778",
        beds: "3"
      }
    ]
  },
  "block 10": {
    title: "traditional towns block 10",
    town: "traditional",
    data: [
      {
        name: "th-3 end upgrade",
        sqft: "2518",
        beds: "3"
      },      
      {
        name: "th-2",
        sqft: "2264",
        beds: "3"
      },
      {
        name: "th-3 end",
        sqft: "2344",
        beds: "3"
      }
    ]
  },
  "block 11": {
    title: "traditional towns block 11",
    town: "traditional",
    data: [
      {
        name: "th-3 end",
        sqft: "2344",
        beds: "3"
      },
      {
        name: "th-1",
        sqft: "2108",
        beds: "3"
      },
      {
        name: "th-3 end upgrade",
        sqft: "2518",
        beds: "3"
      }
    ]
  },
}